export type PhoneFieldValues = {
  prefix: string;
  number: string;
};

function isPhoneFieldValues(phone: string | PhoneFieldValues | undefined): phone is PhoneFieldValues {
  return typeof phone === 'object' && phone !== null && 'prefix' in phone;
}

export function formatPhoneDisplay(phone: string | PhoneFieldValues): string {
  if (typeof phone === 'string') {
    return phone;
  }
  return `${phone.prefix}${phone.number}`;
}

export function normalizePhoneFieldValues(
  phone: string | PhoneFieldValues | undefined,
  defaultPrefix: string,
): PhoneFieldValues {
  if (isPhoneFieldValues(phone)) {
    return {
      prefix: phone.prefix || defaultPrefix,
      number: phone.number ?? '',
    };
  }

  const digits = (phone ?? '').replaceAll(/\D/g, '');
  if (digits.startsWith('420')) {
    return { prefix: '420', number: digits.slice(3) };
  }
  if (digits.startsWith('421')) {
    return { prefix: '421', number: digits.slice(3) };
  }

  return { prefix: defaultPrefix, number: digits };
}
